import FieldConfig from "../../../../proto/field-config";
import Task from "../../../../../model2/task/task";
import FieldUser from "../../../../generic/user/user";
import {FieldDropdown_filterValuesFiller} from "../../../../conditions/dropdown";

export default class FieldTaskCreatedBy extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.icon       = 'i5-user-created'
        this.label      = 'Created by'

        this.showConditionsNotSetOption = false

        this.filterValuesFiller         = FieldDropdown_filterValuesFiller
    }

    canEdit(model:Task):boolean {
        return false
    }
}
